export const EMAIL = "info@adsone.lk";
